(function () {
  // Small cache so we don’t refetch the same product JSON 20 times
  const productJsonCache = new Map();

  function findCardRoot(el) {
    return el.closest("li.products-list-item") || el.closest(".products-list-item") || el.closest(".product");
  }

  function updatePrice(card, price, compare) {
    if (!card) return;

    const priceWrap = card.querySelector(".product__price");
    if (!priceWrap) return;

    const compareEl =
      priceWrap.querySelector(".fl-price-compare") ||
      priceWrap.querySelector(".product__price--compare") ||
      priceWrap.querySelector('[class*="price--compare"]');

    const currentEl =
      priceWrap.querySelector(".fl-price-current") ||
      priceWrap.querySelector(".product__price--current") ||
      priceWrap.querySelector('[class*="price--current"]');

    if (currentEl && price) currentEl.textContent = price;

    if (compare && compare.trim().length) {
      if (compareEl) {
        compareEl.textContent = compare;
        compareEl.style.display = "";
      } else {
        const row = priceWrap.querySelector(".fl-price-row") || priceWrap;
        const span = document.createElement("span");
        span.className = "fl-price-compare";
        span.textContent = compare;
        row.insertBefore(span, row.firstChild);
      }
    } else {
      if (compareEl) compareEl.style.display = "none";
    }
  }

  function updateTitle(card, newTitle, newUrl) {
    if (!card) return;
    const titleLink = card.querySelector(".product__title a");
    if (titleLink) {
      if (newUrl) titleLink.href = newUrl;
      if (newTitle) titleLink.textContent = newTitle;
      if (newTitle) titleLink.title = newTitle;
    }
  }

  function updateQuickview(card, handle, productId) {
    if (!card) return;
    const qv = card.querySelector(".product-quickview");
    if (!qv) return;

    if (handle) qv.setAttribute("data-handle", handle);
    if (productId) qv.setAttribute("data-product-id", productId);
  }

  function markCurrentDot(scope, btn) {
    if (!scope) return;
    scope.querySelectorAll(".fl-card-swatch__dot.is-current").forEach((d) => d.classList.remove("is-current"));
    if (btn) btn.classList.add("is-current");
  }

  function setLinkTargets(card, newUrl, newTitle) {
    const imageLink = card.querySelector(".product__image a");
    if (imageLink && newUrl) {
      imageLink.href = newUrl;
      if (newTitle) imageLink.title = newTitle;
    }
  }

  function setImgEverywhere(img, url, alt) {
    if (!img || !url) return;

    // Hard-set src and neutralize responsive attributes that would “fight back”
    img.src = url;
    img.removeAttribute("srcset");
    img.removeAttribute("sizes");

    // Common lazyload data-attrs (safe to set if present)
    if (img.dataset) {
      if ("src" in img.dataset) img.dataset.src = url;
      if ("original" in img.dataset) img.dataset.original = url;
      if ("lazySrc" in img.dataset) img.dataset.lazySrc = url;
    }

    if (alt) img.alt = alt;

    // If the browser had it lazy, force re-evaluation
    img.loading = img.loading || "eager";
  }

  async function fetchProductJsonByHandle(handle) {
    if (!handle) return null;
    if (productJsonCache.has(handle)) return productJsonCache.get(handle);

    const p = fetch(`/products/${handle}.js`, { credentials: "same-origin" })
      .then((r) => (r.ok ? r.json() : null))
      .catch(() => null);

    productJsonCache.set(handle, p);
    return p;
  }

  /**
   * ✅ Fix for your theme’s hover image:
   * - Your card has primary + secondary image blocks.
   * - Previously you updated only the first <img>, so hover still showed the old secondary.
   * - Now we update BOTH:
   *   - primary: .product__image a img (the “main” image in the link)
   *   - secondary: .product__image-secondary img (hover image)
   *
   * Data strategy:
   * - Use data-target-image if present (fast).
   * - For secondary image, if you have data-target-image-secondary use it.
   * - If not, we fetch /products/<handle>.js and take images[0] + images[1] (fallback).
   */
  async function updateImages(card, opts) {
    if (!card) return;

    const {
      imageUrl, // data-target-image (featured)
      secondaryImageUrl, // OPTIONAL: data-target-image-secondary (if you add it later)
      newUrl,
      newTitle,
      handle,
    } = opts || {};

    setLinkTargets(card, newUrl, newTitle);

    // Find image nodes in the card (Haula pattern)
    const primaryImg =
      card.querySelector(".product__image a img") ||
      card.querySelector(".product__image img");

    const secondaryImg =
      card.querySelector(".product__image-secondary img") ||
      card.querySelector(".product__image .product__image-secondary img");

    // Decide URLs:
    // 1) Primary: use dataset if provided
    // 2) Secondary: use dataset if provided
    // 3) If secondary missing, pull from product JSON (keeps hover working)
    let primary = imageUrl || null;
    let secondary = secondaryImageUrl || null;

    if ((!primary || !secondary) && handle) {
      const json = await fetchProductJsonByHandle(handle);
      if (json && Array.isArray(json.images)) {
        if (!primary && json.images[0]) primary = json.images[0];
        if (!secondary && json.images[1]) secondary = json.images[1];
      }
    }

    // If still no secondary, don’t break hover: keep the existing secondary as-is.
    // (Or, as a last fallback, set secondary = primary so hover is consistent.)
    if (!secondary && primary) {
      // safest: set secondary=primary so hover doesn’t “flash” old color
      secondary = primary;
    }

    // Apply
    if (primaryImg && primary) setImgEverywhere(primaryImg, primary, newTitle);
    if (secondaryImg && secondary) setImgEverywhere(secondaryImg, secondary, newTitle);

    // Also update ANY extra imgs inside the image link (some themes render multiple)
    const allImgsInLink = card.querySelectorAll(".product__image a img");
    if (allImgsInLink && allImgsInLink.length > 1 && primary) {
      allImgsInLink.forEach((img, idx) => {
        // Keep first as primary, others (if any) set to primary too to avoid mismatches
        if (idx === 0) setImgEverywhere(img, primary, newTitle);
        else setImgEverywhere(img, primary, newTitle);
      });
    }
  }

  document.addEventListener("click", async function (e) {
    const btn = e.target.closest("[data-fl-swatch]");
    if (!btn) return;

    e.preventDefault();

    const card = findCardRoot(btn);
    if (!card) return;

    const newUrl = btn.getAttribute("data-target-url");
    const newTitle = btn.getAttribute("data-target-title");
    const price = btn.getAttribute("data-target-price");
    const compare = btn.getAttribute("data-target-compare");
    const image = btn.getAttribute("data-target-image");
    const handle = btn.getAttribute("data-target-handle");
    const productId = btn.getAttribute("data-target-product-id");

    // 1) Update text bits immediately (feels instant)
    updateTitle(card, newTitle, newUrl);
    updatePrice(card, price, compare);
    updateQuickview(card, handle, productId);

    // 2) Update image(s) in a way that keeps hover working
    await updateImages(card, {
      imageUrl: image,
      // If later you add this attribute in Liquid, we’ll use it automatically:
      secondaryImageUrl: btn.getAttribute("data-target-image-secondary"),
      newUrl,
      newTitle,
      handle,
    });

    // 3) Active dot state
    const swatchRow = btn.closest(".fl-card-swatches");
    markCurrentDot(swatchRow, btn);
  });
})();